// # Shared Header Component
import React from 'react';
import { useAuthStore } from '../auth/state';
import DashboardHeader from './DashboardHeader';  // Updated import path
import LandingHeader from '../landing/components/header';

function SharedHeader() {
  const { isAuthenticated } = useAuthStore();

  return isAuthenticated ? <DashboardHeader /> : <LandingHeader />;
}

export default SharedHeader; 